import styled from 'styled-components';
import NextImage from 'next/image';

export const Wrapper = styled.div`
  padding: 80px 40px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const Client = styled.span`
  color: #444;
`;

export const Title = styled.h1`
  text-transform: uppercase;
  font-size: 32px;
  margin-bottom: 10px;
`;

export const Hero = styled(NextImage)`
  margin-bottom: 20px !important;
`;

export const TechTagsWrapper = styled.div`
  position: relative;
  margin-bottom: 40px;
  line-height: 1.5rem;
  max-width: 500px;
`;

export const TechTag = styled.span`
  display: inline-block;
  background: #eee;
  color: #111;
  padding: 1px 6px;
  margin: 5px;
  border-radius: 2px;
`;

export const Description = styled.p`
  font-size: 13px;
  width: 600px;
  line-height: 1.5rem;
  white-space: pre-wrap;
  margin-bottom: 20px;
`;

export const Label = styled.span`
  display: block;
  text-transform: uppercase;
  color: #444;
  font-size: 11px;
  line-height: 1.5rem;
`;

export const Video = styled.video`
  position: relative;
  width: calc(min(50vw, 600px) - 80px);
  padding: 6px;
`;

export const Gallery = styled.ul`
  margin-top: 20px;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
`;

export const Image = styled(NextImage)`
  padding: 6px !important;
`;

export const ImageWrapper = styled.li`
  position: relative;
  width: ${({ type }) =>
    type === 'desktop'
      ? 'calc(min(50vw, 600px) - 80px)'
      : 'calc(min(30vw, 350px) - 80px)'};
  height: ${({ type }) =>
    type === 'desktop'
      ? 'calc(min(31vw, 370px) - 80px)'
      : 'calc(min(45vw, 560px) - 80px)'};
`;
